<template>
    <div style="background:white; height:100%">     
        <div style=" display:flex;  min-width:750px;width:100%; background:#fff;line-height:30px;height:38px;border-bottom:2px solid #389;padding-top:3px">   
            <div style="font-size:12px;margin-right:5px;margin-left:3px">年份</div>
            <el-select v-model="v_year" @change="getTreeBar" placeholder="请选择"  filterable  size="small" style="width:90px; ">
                <span v-for="item in yrArr" :key='item.key' >
                    <el-option :label="item.CNAME" :value="item.CODE"  ></el-option>
                </span>
            </el-select>
            <!-- <div style="font-size:12px;margin-right:5px;margin-left:15px">客户</div>
            <el-select v-model="v_clnt"  placeholder="请选择"  filterable  size="small" style="width:280px; ">
                <span v-for="item in clntArr" :key='item.key' >
                    <el-option :label="item.CLNTNM" :value="item.CLNTNO"  ></el-option>
                </span>
            </el-select>
            <el-button type="primary" icon="iconfont icon-jinduchaxun" size="mini" style="margin-left:15px">查询</el-button> -->
            
            <div style="font-size:12px;margin-right:5px;margin-left:15px">计划</div>
            <div style="background:#d71345;width:20px;height:20px;margin-top:6px"> </div>
            <div style="font-size:12px;margin-right:5px;margin-left:15px">实际</div>
            <div style="background:green;width:20px;height:20px;margin-top:6px"> </div>

            <div style="font-size:12px;margin-right:5px;margin-left:15px">计划总额：</div>
            <div style="font-size:13px;font-weight:700;color:#d71345"> {{v_planSum}} 万元</div>
            <div style="font-size:12px;margin-right:5px;margin-left:15px">实际总额：</div>
            <div style="font-size:13px;font-weight:700;color:green"> {{v_actSum}} 万元</div>
            <div style="font-size:13px; margin-left:15px;font-weight:600">提示：每隔5分钟更新数据</div>
        </div> 
        <div  :style="{width: '100%', height:tabHeight  }">
            <div style="height:100%; "   id="lineId" ></div>
        </div>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 销售明细单据 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="planWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 明细资料 </span>
            </div> 
            <div style="overflow-y:auto;height:88vh"> 
                <div class="one-toolbar"><div class="spanRow">销售计划</div></div>
                <el-table  :data="tabData" 
                        border                            
                        disabled-hover
                        class="custom-table-border"
                        style="overflow:auto;margin-top:-8px;"
                        :cell-style="{padding:'2px'}"
                        size="small"
                        :height="320" 
                        ref="tabref"
                        :row-key="getRowKey"  
                        show-summary
                        :summary-method="getTotal"
                        highlight-current-row>
                    <el-table-column label="序号" type="index" width="60"></el-table-column>
                    <el-table-column  v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" disabled false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <div v-else  >{{scope.row[item.key]}}</div>
                        </template>
                    </el-table-column>                     
                </el-table>  
                <div class="one-toolbar"><div class="spanRow">实际销售</div></div>
                <el-table  :data="saleData" 
                        border                            
                        disabled-hover
                        style="overflow:auto;margin-top:-8px;"
                        :cell-style="{padding:'2px'}"
                        size="small"
                        :height="450" 
                        class="custom-table-border"
                        ref="refsale"
                        :row-key="getRowKey"  
                        show-summary
                        :summary-method="getSummary"
                        highlight-current-row>
  
                    <el-table-column  v-for="(item,index ) in saleCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                        :min-width="item.width">
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" disabled false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <div v-else  >{{scope.row[item.key]}}</div>
                        </template>
                    </el-table-column>                     
                </el-table>
            </div>
        </el-dialog>
 
 
    </div>
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate ,format_number} from '../../api/Select' 
//局部注册
export default {
    name:"sale_chart",
    data () {
        return {
            v_radio:'PRD',
            nextWin:false,
            allSel:'N',
            supval:'',
            dateval:'',
            v_actSum:'0',
            v_planSum:'',
            planWin:false,
            saleData:[],
            saleCol:[],
            invInstance: null,
 
            promptWin:false,
            prompt:'',
 
   
            disabled:false, //新增权限制
 
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            dtlValidate:{},
        
            tabData:[], //表数据
       
            tabCol:[], //表列
 
            comboArr:{},
            txtparam:'',
 
            v_clnt:'',
            v_year:'',
            delArr:[],
 
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            notDtl:[],
            current:1,
  
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            yrArr:[],      
            v_stknm :'',
            clntArr:[] ,
            v_key:'',
            v_tabRow:{},
            v_tabIndex:'',
 
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
 
            v_idno:'',
            v_replist:[],
 
 
            ordData:[],
            mthData:[],
    
        }
    },
    mounted () { 
        this.v_year =getDate('yr')
        //柱状图 
        this.getTreeBar()  
 
        //用户表单新增、编辑、审核、作废权限 :frmid:  ID
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','419614','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        getBaseData('xuper_auth/getTableRecMany','corpid',this.v_corpid,'','','V_SALE_PLAN_CLNT','').then(res=>{
            this.clntArr =res.result
        })
        getBaseData('xuper_auth/getTableRecMany','corpid',this.v_corpid,'','','V_SALE_PLAN_YEAR','').then(res=>{
            this.yrArr =res.result
        })
     
        this.reFresh() //定时刷新
    },
    computed: {
 
        tabHeight: function() {
            return (window.innerHeight - 120) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
 
    },
    components: {
 
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: { 
        // 定时刷新
        reFresh(){
            // 每隔5分钟刷新一次
            let  timer = setInterval(() => {
                setTimeout(()=>{
     
                    this.getTreeBar()
                    //console.log('5 minutes ...')
                    //clearInterval(timer)
                }, 0)
            }, 60000*5)
            
        },
        //初始化
        getInit(){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: {p_cond:' SELECT  TO_CHAR(SUM(NVL(AMT,0))/10000,\'FM999G999G999G999\')  AMT FROM V_SALE_PLAN WHERE CORPID=\''+this.v_corpid+'\' and yr=\''+this.v_year+'\' ' },
            }).then(res=>{
                if (res.code=='200'){
                    this.v_planSum =res.result[0]['AMT']
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: {p_cond:' SELECT  TO_CHAR(SUM(NVL(AMT,0))/10000,\'FM999G999G999G999\')  AMT FROM V_SALE_ORD WHERE CORPID=\''+this.v_corpid+'\' and yr=\''+this.v_year+'\' ' },
            }).then(res=>{
                if (res.code=='200'){
                    this.v_actSum =res.result[0]['AMT']
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
        },
        //对指定列进行合计 
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY'||column.property==='AMT'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return  Number(Number(prev) +Number(curr) ).toFixed(1) 
                        }else{
                            return  prev 
                        }
                    },'')
                }
            })
            return  sums 
        },
        getTotal(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY'||column.property==='AMT'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return  Number(Number(prev) +Number(curr) ).toFixed(1) 
                        }else{
                            return  prev 
                        }
                    },'')
                }
            })
            return  sums 
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //柱状图
        getTreeBar(){
            this.mthData=[]
            this.ordData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: {p_cond:' SELECT TO_NUMBER(MTH) MTH,SUM(NVL(AMT,0))/10000  AMT FROM V_SALE_PLAN WHERE CORPID=\''+this.v_corpid+'\' and yr=\''+this.v_year+'\' GROUP BY MTH order by mth' },
            }).then(res=>{ 
                // for(let k=0;k<res.result.length;k++){
                //     this.mthData.push(res.result[k]['AMT'] )
                // } 
                let v_mth =[]
                for(let k=0;k<res.result.length;k++){
                    v_mth.push({'KEY':res.result[k]['MTH'],VAL:res.result[k]['AMT'] })
                } 
                for(let  k =1; k<13; k++){  //当某个月没有 输入计划时 ，补全 12个月
                    let v_val=''
                    v_mth.some(item =>{
                        if (item['KEY']==k){
                            v_val =item['VAL']
                        } 
                    })
                    this.mthData.push(v_val)
                } 
                //实际销售
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getFreeData',
                    data: {p_cond:' SELECT TO_NUMBER(MTH) MTH,SUM(NVL(AMT,0))/10000  AMT FROM V_SALE_ORD WHERE CORPID=\''+this.v_corpid+'\' and yr=\''+this.v_year+'\' GROUP BY MTH  order by mth' },
                }).then(res=>{ 
                    let v_act=[]
                    for(let k=0;k<res.result.length;k++){
                        v_act.push({'KEY':res.result[k]['MTH'],VAL:res.result[k]['AMT'] })
                    } 
                    for(let  k =1; k<13; k++){
                        let v_val=''
                        v_act.some(item =>{
                            if (item['KEY']==k){
                                v_val =item['VAL']
                            } 
                        })
                        this.ordData.push(v_val)
                    } 
                    this.lineChart() 
                })
                this.getInit()
            }) 
        },
        lineChart(){
            let that =this
            if (!this.invInstance) {
                this.invInstance = this.$echarts.init(document.getElementById("lineId"))
            }
            let option = {
                color: ['#f44'],
                grid:{
                        //与绝对定位相似，top，left，right，bottom 设定是根据上级盒子宽高来计算
                        top:"10px",
                        left:"50px",
                        right:"5px",
                        bottom:"20px",
                         
                    },
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {
                            type : 'shadow'
                        }
                    },
                    xAxis : [
                        {
                            type : 'category',
                            data : ['01月','02月','03月','04月','05月','06月','07月','08月','09月','10月','11月','12月',],
                            axisTick: {
                                alignWithLabel: true, // 图形于标题居中
                            }
                        }
                    ],
                    yAxis : [
                        {
                            type : 'value',
                            axisLabel: {
                                show:true,
                                formatter: '{value} 万' ,
                                textStyle: {
                                    fontFamily:'微软雅黑',
                                    color: "#389",
                                    fontSize: '10',
                                    fontWeight:'bold',                                   
                                },                           
                            }
                        }
                    ],
                    series : [
                        {
                            name:'计划销售',
                            type:'bar',
                            barWidth: '30%',
                            data: this.mthData ,
                            itemStyle:{
                                borderRadius:[8,8,0,0],
                                color: '#d71345',
                            },
                            label:{
                                //值显示到柱子上
                                show:true,
                                position:'top',
                                fontSize:10
                            }
                        },
                        {
                            name:'实际销售',
                            type:'bar',
                            barWidth: '30%',
                            data: this.ordData  ,
                            itemStyle:{
                                borderRadius:[8,8,0,0],
                                color: 'green',
                            },
                            label:{
                                //值显示到柱子上
                                show:true,
                                position:'top',
                                fontSize:10
                            }
                        }
                    ]
                };
            that.invInstance.setOption(option,true);
            that.invInstance.on('click',params=>{
                this.getBar(params.name )
            })

        } ,
        getBar(val){
            this.planWin =true
            let v_cond =' and yr='+this.v_year+' and mth='+val.replace('月','')
            this.getPlanList(v_cond)
        },
        //订单明细
        getPlanList(cond){
            this.tabData =[]
            this.saleData =[]
            //获取 计划销售      
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond +' order by mth',p_table:'V_SALE_PLAN'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData =res.result  

                }else{
                    this.promptWin=true
                    this.prompt=res.code+':'+res.result
                }
                this.$nextTick(()=>{this.$refs['tabref'].doLayout()})
            }) 
            //获取 实际销售
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond +' order by mth',p_table:'V_SALE_ORD'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.saleData =res.result  

                }else{
                    this.promptWin=true
                    this.prompt=res.code+':'+res.result
                }
                this.$nextTick(()=>{this.$refs['refsale'].doLayout()})
            }) 
        },
  
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412732','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','123','lstseq','5','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.saleCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        height:18px;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 